<template>
  <div class="card">
    <div class="card-body">
      <b-table
        class="datatables"
        responsive="sm"
        :items="items"
        :fields="fields"
        per-page="10"
        :current-page="currentPage"
        bordered
        striped
      >

        <template #cell(DTNASCIMENTO)="data">
          <div class="d-flex align-items-center justify-content-between">
            <span>{{ data.item.DTNASCIMENTO }} </span>
            <i v-if="dataAniversario(data.item.DTNASCIMENTO)"
              class="mdi mdi-cake-variant mx-2 fs-4 text-success"></i>
          </div>
        </template>

        <template #cell(NMMUNICIPIO)="data">
          <div class="d-flex align-items-center justify-content-between">
            <span v-if="data.item.NMMUNICIPIO">
              {{ data.item.NMMUNICIPIO }} - {{ data.item.DSUF }}
            </span>
          </div>
        </template>

        <template #cell(interacao)="data">
          <div class="d-flex justify-content-center">
            <b-button
              size="sm"
              variant="primary"
              class="me-1"
              @click="emitirEditarItem(data.item)"
              :disabled="loadingAcoes"
            >
              <i class="mdi mdi-pencil"></i>
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              @click="deletarClienteRural(data.item)"
              :disabled="loadingAcoes"
            >
              <i class="mdi mdi-trash-can"></i>
              <b-spinner
                variant="primary"
                small
                class="ms-2"
                v-if="loadingAcoes"
              ></b-spinner>
            </b-button>
          </div>
        </template>
      </b-table>

      <div class="d-flex justify-content-end mt-3">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="itemsPerPage"
          class="pagination pagination-rounded mb-0"
        />
      </div>
    </div>
  </div>
</template>


<script>
import Swal from "sweetalert2";

export default {
  name: "Grid",
  props: {
    filtro: {
      type: Object,
      default: () => ({})
    },
    items: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      fields: [
        {
          key: "SQCLIENTE",
          label: "Código",
          descricao: "Código do cliente",
          sortable: true
        },
        {
          key: "NMRAZAO",
          label: "Cliente Rural",
          descricao: "Nome do cliente rural",
          sortable: true
        },
        {
          key: "NRCPFCNPJ",
          label: "CPF/CNPJ",
          descricao: "Documento de identificação",
          sortable: true
        },
        {
          key: "NRTELEFONE",
          label: "Telefone",
        },
        {
          key: "DSEMAIL",
          label: "E-mail",
          descricao: "Endereço de e-mail",
          sortable: true
        },
        {
          key: "NMMUNICIPIO",
          label: "Município",
          descricao: "Nome do município",
          sortable: true
        },
        {
          key: "DTNASCIMENTO",
          label: "Data Nascimento",
          descricao: "Data de nascimento do cliente",
          sortable: true
        },
        {
          key: "interacao",
          label: "Ações"
        }
      ],
      currentPage: 1,
      itemsPerPage: 10,
      loadingAcoes: false,
    };
  },
  computed: {
    totalRows() {
      return this.items.length;
    }
  },
  methods: {
    emitirEditarItem(item) {
      this.$emit("editarItem", item);
      console.log(item)
    },

    deletarClienteRural(item) {
      Swal.fire({
        title: "Tem certeza?",
        text: "Você realmente deseja excluir este cliente rural? Essa ação não pode ser desfeita.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.loadingAcoes = true;
          var obj = {
            cdCooperado: item.CDCOOPERADO,
            sqCliente: item.SQCLIENTE,
          };
          this.$http.post("/api/astec/deletarClientesRurais", obj)
            .then(() => {
              Swal.fire({
                icon: "success",
                title: "Sucesso",
                text: "Cliente rural excluído com sucesso!",
              });
              this.$emit('clientesRuraisFiltrados', this.$store.state.filtroClienteRuralAstec, () => {
              });
            })
            .catch(err => {
              console.log("Erro ao deletar cliente rural", err.response.data);
              this.$tools.alerta(err.response.data, "error");
            })
            .finally(() => {
              this.loadingAcoes = false;
            });
        }
      });
    },


    dataAniversario(dataNascimento) {
      if (!dataNascimento) return false;
      const hoje = new Date();
      const [dia, mes] = dataNascimento.split("/").slice(0, 2);
      return (
        parseInt(dia) === hoje.getDate() &&
        parseInt(mes) === hoje.getMonth() + 1
      );
    },
  }
};
</script>

